import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _ProductLocationCatalog, _ProductVariant } from "../../../core/services/dataBean/EntityCatalogVdos";
import { SelectStoreEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { BasicButton } from "../../theme/Component/BasicButton";


interface Props {
    Product: number;
}

export const ProductVariant = ({ Product }: Props) => {

    const location = useDataBean(_ProductVariant);
    const [IDStore, setIDStore] = useState<number>(null)
    const single = Singleton.getInstance();
    const Configurar = useDataBean(_ProductVariant);
    const [lista, setLista] = useState<any>([]);
    const [table, setTable] = useState<any>({ name: 'Variantes y Tallas', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista()
    }, [Product])

    const getLista = () => {

        Configurar.instance.getProductVariantCatalog(Product).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        location.setBean({
            IDProduct: Product
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {

        location.deleteItemVoid(location.bean.IDProductVariant).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )
    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        location.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDProductVariant', visible: true },
        { title: 'ID Porducto', property: 'IDProduct', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Referencia de Producto', property: 'Reference', visible: true },
        { title: 'Precio de Venta', property: 'PriceValue', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">

                <div className="row">
                    {/* <div className="col-md-6"> <BasicButton value="Consultar Tabla" icon="ri-play-list-add-fill" eventClick={getLista} ></BasicButton></div> */}
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={location.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    </div>
                </div>





            </div>
            <div className="col-md-12">

                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">

                        <div className="col-md-6">
                            <label>Referencia de Producto</label>
                            <input type="text" name="Reference" className="form-control" value={location.bean.Reference} onChange={location.handleChange} />
                            {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                        </div>
                        <div className="col-md-6">
                            <label>Nombre</label>
                            <input type="text" name="Name" className="form-control" value={location.bean.Name} onChange={location.handleChange} />
                            {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                        </div>
                        <div className="col-md-12">
                            <label>Precio de Venta</label>
                            <input type="text" name="PriceValue" className="form-control" value={location.bean.PriceValue} onChange={location.handleChange} />
                        </div>



                        <div className="col-md-12">
                            <label>Description</label>
                            <textarea name="Description" className="form-control" value={location.bean.Description} onChange={location.handleChange} />
                        </div>
                        {/* <PrintJson json={SubMacroProcess.bean} /> */}
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}